import { Star, Shield, Ban, Heart } from "lucide-react";

const testimonials = [
  {
    name: "Sarah Johnson",
    location: "New York, NY",
    text: "My daughter Olivia asks for 'her story' every night now. She loves hearing her name in the adventures!",
    rating: 5,
    gradient: "from-[hsl(var(--playful-pink),0.2)] to-[hsl(var(--playful-purple),0.2)]",
  },
  {
    name: "Chris Miller",
    location: "Palo Alto, CA",
    text: "Finally something that teaches values without boring lectures. My son actually learned to share!",
    rating: 5,
    gradient: "from-[hsl(var(--playful-purple),0.2)] to-[hsl(var(--playful-teal),0.2)]",
  },
  {
    name: "Jennifer Williams",
    location: "Phoenix, AZ",
    text: "The daughter absolutely hated brushing her teeth! But the stories have changed her dramatically!",
    rating: 5,
    gradient: "from-[hsl(var(--playful-teal),0.2)] to-[hsl(var(--playful-yellow),0.2)]",
  },
];

const trustBadges = [
  { icon: Shield, label: "Safe for Kids", color: "text-[hsl(var(--playful-teal))]" },
  { icon: Ban, label: "No Ads Ever", color: "text-[hsl(var(--playful-pink))]" },
  { icon: Heart, label: "Reduced screen time", color: "text-[hsl(var(--playful-orange))]" },
];

const SocialProofSection = () => {
  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-background via-[hsl(var(--playful-pink),0.05)] to-background relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 text-4xl opacity-20 animate-float">⭐</div>
        <div className="absolute top-20 right-20 text-3xl opacity-20 animate-float" style={{ animationDelay: "1s" }}>✨</div>
        <div className="absolute bottom-20 left-20 text-3xl opacity-20 animate-float" style={{ animationDelay: "2s" }}>🌟</div>
        <div className="absolute bottom-10 right-10 text-4xl opacity-20 animate-float" style={{ animationDelay: "0.5s" }}>💫</div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        {/* Stats */}
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-[hsl(var(--playful-yellow),0.3)] to-[hsl(var(--playful-orange),0.3)] rounded-3xl px-8 py-6 mb-8 border-2 border-[hsl(var(--playful-yellow),0.3)]">
            <p className="font-display text-4xl md:text-5xl font-bold bg-gradient-to-r from-[hsl(var(--playful-orange))] to-[hsl(var(--playful-pink))] bg-clip-text text-transparent">
              100,000+
            </p>
            <p className="text-muted-foreground font-medium">
              Stories created by parents
            </p>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {trustBadges.map((badge, index) => (
              <div key={index} className="flex items-center gap-2 bg-card px-4 py-2 rounded-full border border-border shadow-sm">
                <badge.icon className={`w-5 h-5 ${badge.color}`} />
                <span className="text-sm font-medium text-foreground">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${testimonial.gradient} rounded-3xl p-6 border border-border/50 hover:shadow-lg transition-all duration-300 hover:scale-[1.02]`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[hsl(var(--playful-yellow))] text-[hsl(var(--playful-yellow))]" />
                ))}
              </div>
              <p className="text-foreground mb-4 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div>
                <p className="font-semibold text-foreground">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
